/**
 * @generated SignedSource<<77f06c030c215b3a13f4bf51cb03a959>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductVideo_viewer$data = {
  readonly muxMonitoringFF: boolean | null;
  readonly vimeoItemsVideoHLSPlayerFF: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"ProductVideoRefetch_viewer">;
  readonly " $fragmentType": "ProductVideo_viewer";
};
export type ProductVideo_viewer$key = {
  readonly " $data"?: ProductVideo_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductVideo_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductVideo_viewer",
  "selections": [
    {
      "alias": "vimeoItemsVideoHLSPlayerFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "vimeoItemsVideoHLSPlayer"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"vimeoItemsVideoHLSPlayer\")"
    },
    {
      "alias": "muxMonitoringFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "muxMonitoring"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"muxMonitoring\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductVideoRefetch_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "9009c1328a8783cdf020308927a1cfdf";

export default node;
